import styled from 'styled-components';

const SectionTitle = styled.h1`
  margin-bottom: 40px;
  text-align: center;
	color: #f0f0f0;
	width: 100%;
	font-size: 3rem;
	font-weight: 700;
`;

export default SectionTitle;